/**
 * Session configuration — single source of truth.
 *
 * IDLE_TIMEOUT_MS: auto-logout fires after this much time with NO user activity
 * (mouse, keyboard, scroll/touch, click, or route navigation). Any activity
 * resets the countdown. This is an *inactivity* timeout only — active users are
 * never logged out; the access token is refreshed silently in the background
 * (see the 401 interceptor in utils/api.ts) for as long as the refresh token
 * (7-day TTL) remains valid.
 */
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
